export default __webpack_public_path__ + "static/media/proyecto_pagina.f8470331.PNG";